import type { ReactNode } from 'react'

interface DropdownMenuProps {
    children: ReactNode
    className?: string
}

export function DropdownMenu({ children, className = '' }: DropdownMenuProps) {
    return <div className={`py-1 ${className}`}>{children}</div>
}
